import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ModalAlert } from '../modal.alert/modal.alert.component';
import { NetworkingContract } from '../../../../services/contrato/networking.contract';
import {
  campanias,
  ContratPeopleResponse,
  documentType,
  QuotationPeopleResponse,
  ContratosActivos,
} from '../../../../models/cotizador/response/model.data.response';
import { SnackBarService } from '../../../../utils/util.SnackBarService';
import { StorageService } from '../../../../utils/util.storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Base } from '../../base';
import { NetworkingQuotation } from '../../../../services/servicioCotizador/cotizador.service';

NgxSpinnerService;
interface ListHomo {
  linea: { codigo: number; nombre: string; }[];
  plan: { codigo: string; nombre: string; }[];
  programa: { codigo: string; nombre: string; }[];
}

interface DialogColectivoModalData {
  opciones?: boolean;
  data?: ContratosActivos[];
  select?: any;
  tipoPlan?: string;
  tipoSolicitud?: string;
  isEditMode?: boolean;      
  tipoDocumento?: string;    
  numeroDocumento?: string; 
}

@Component( {
  selector: 'app-dialog-colectivo',
  templateUrl: './dialog-colectivo.component.html',
  styleUrls: [ './dialog-colectivo.component.css' ],
} )
export class DialogColectivoComponent extends Base {
  private readonly documentoAlfanumericoPattern = /^[A-Za-z0-9]*$/;
  private readonly documentoAlfanumericoMensaje = 'Solo se permiten caracteres alfanuméricos (A-Z, a-z, 0-9).';

  // RQ001: en Venta nueva con Colectivo / Grupos de Afinidad, el campo
  // Tipo de documento NO debe mostrar BG, CN, RC ni TI. Se filtra por
  // codigo porque el descriptivo varia (mayusculas, tildes, etc.).
  private readonly excludedDocumentTypeCodes = new Set( [
    'BG', // Bebe gestante
    'CN', // Nacido vivo
    'RC', // Registro civil de nacimiento
    'TI', // Tarjeta de identidad
  ] );

  typeDocument: Array<documentType> | undefined;

  form = {
    documento: {
      value: null as string | null,
      messages: null as string | null,
      required: true,
    },
    tipoDocumento: {
      value: 'NI' as string | null,
      messages: null as string | null,
      required: true,
    },
  };

  listContrato = Array<ContratosActivos>();

  //listContrato = Array<ContratPeopleResponse>();

  listHomo: ListHomo = {
    linea: [
      { codigo: 1, nombre: 'Medicina Integral' },
      { codigo: 2, nombre: 'Salud Oral' },
    ],
    plan: [
      { codigo: 'A', nombre: 'Asociado' },
      { codigo: 'C', nombre: 'Colectivo' },
      { codigo: 'AS', nombre: 'Asesor' },
      { codigo: 'EM', nombre: 'Empleado' },
    ],
    programa: [
      { codigo: 'CLAS', nombre: 'CLASICO' },
      { codigo: 'ASO', nombre: 'ASOCIADO' },
      { codigo: 'OR12', nombre: 'ORO' },
    ],
  };

  valContratos: ContratosActivos[] = [];
  estado = true;
  opcionesNew: boolean = false;
  opciones = false;
  valPersona: any;
  documento: string = '';
  selectedTipoDocumento: string = 'NI';
  datosEmpresa: any;

  asesorLogueado: {
    tipo: string;
    nombre: string;
    activo: boolean;
  } | null = null;

  asesorContratante: {
    tipo: string;
    nombre: string;
  } | null = null;

  constructor(
    private networking: NetworkingContract,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
    private storageService: StorageService,
    private renderer: Renderer2,
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<DialogColectivoComponent>,
    public networkingQuotation: NetworkingQuotation,
    @Inject( MAT_DIALOG_DATA ) public dialogData: DialogColectivoModalData,
  ) {
    super();
    if ( this.dialogData != null ) {
      this.listContrato = this.dialogData.data == null ? [] : this.dialogData.data;
      this.opciones = !!this.dialogData.opciones;
    }
  }

  ngOnInit(): void {
    if (this.dialogData?.tipoDocumento) {
      this.selectedTipoDocumento = this.dialogData.tipoDocumento.trim();
    } else {
      this.selectedTipoDocumento = 'NI';
    }

    if (this.dialogData?.numeroDocumento) {
      this.documento = this.dialogData.numeroDocumento.toString().trim();
    }

    this.networkingQuotation.obtenerTipoDocumento().subscribe( {
      next: ( tipos ) => ( this.typeDocument = this.filterDocumentTypes( tipos ) ),
      error: ( err ) => console.error( err ),
    } );

    const contratosDialogo = this.dialogData?.data ?? [];
    if ( contratosDialogo.length > 0 ) {
      this.listContrato = contratosDialogo;
      this.opciones = true;
      this.opcionesNew = true;
      this.valContratos = this.dialogData?.select ?? [];
    } else {
      this.listContrato = [];
      this.opciones = true;
      this.opcionesNew = false;
      this.valContratos = [];
    }

    if (this.documento) {
      console.log('[Colectivo-Edicion] Disparando auto-consulta para NIT/Documento:', this.documento);
      setTimeout(() => {
        this.searchEmpresa();
      }, 200);
    }
  }

  invertirNombreCompleto( nombre: string ): string {
    if ( !nombre ) return '';

    const partes = nombre.trim().split( /\s+/ );

    if ( partes.length <= 2 ) {
      return nombre; // no hay forma confiable de invertir
    }

    const nombres = partes.slice( 2 ).join( ' ' );
    const apellidos = partes.slice( 0, 2 ).join( ' ' );

    return `${ nombres } ${ apellidos }`;
  }

  private filterDocumentTypes( tipos: Array<documentType> ): Array<documentType> {
    return tipos.filter( ( tipo ) => {
      const codigo = ( tipo?.codigo ?? '' ).trim().toUpperCase();
      return !this.excludedDocumentTypeCodes.has( codigo );
    } );
  }

  private esVentaNueva(): boolean {
    return ( this.dialogData?.tipoSolicitud ?? '' ).toString().trim() === '1';
  }
  private esColectivoVentaNueva(): boolean {
    return ( this.dialogData?.tipoSolicitud ?? '' ).toString().trim() === '3';
  }

  private requiereValidacionDocumentoAlfanumerico(): boolean {
    return (this.esVentaNueva() || this.esColectivoVentaNueva()) && this.isPlanColectivo( this.getTipoPlanSeleccionado() );
  }

  onDocumentoInput(): void {
    if ( !this.requiereValidacionDocumentoAlfanumerico() ) {
      this.form.documento.messages = null;
      return;
    }

    const documento = ( this.documento ?? '' ).toString();

    if ( !documento.length ) {
      this.form.documento.messages = null;
      return;
    }

    this.form.documento.messages = this.documentoAlfanumericoPattern.test( documento )
      ? null
      : this.documentoAlfanumericoMensaje;
  }

  searchEmpresa(): void {
    console.log( 'Tipo de plan al buscar empresa:', this.getTipoPlanSeleccionado() );

    const tipoDocumento = this.selectedTipoDocumento;
    const documento = ( this.documento ?? '' ).toString().trim();

    this.documento = documento;
    this.onDocumentoInput();

    if ( this.form.documento.messages ) {
      return;
    }

    this.spinner.show();

    if ( !tipoDocumento || !documento ) {
      this.spinner.hide();
      this.openDialog(
        this.dialog,
        'Debe ingresar tipo y número de documento.',
        '',
        0,
        ( r: boolean ) => { },
      );
      return;
    }

    // NC0012 / alcance adicional: getDatosxEmpresa trae cuenta_tipo C=Colectivo, A=GA.
    const tipoPlan = this.getTipoPlanSeleccionado();
    const cuentaTipo =
      tipoPlan === 'C' ? 'C' :
      tipoPlan === 'GA' ? 'A' :
      undefined;

    this.networkingQuotation
      .consultarDatosXEmpresa( tipoDocumento, documento, cuentaTipo )
      .subscribe(
        ( response: any ) => {
          this.spinner.hide();
          this.searchEmpresaOutputSuccessful( response );
        },
        ( error ) => {
          this.searchEmpresaOutputFailure( error );
        },
      );
  }

  searchEmpresaOutputSuccessful(data: any): void {
    const tipoPlan = this.getTipoPlanSeleccionado();

    console.log('Respuesta de la consulta:', data);
    console.log('Tipo de plan seleccionado:', tipoPlan);

    const mensajePorPlan =
      this.getMensajeNoVigentePorTipoPlan(tipoPlan);

    const esGrupoAfinidad = tipoPlan === 'GA';
    const esColectivo = tipoPlan === 'C';

    const sinInformacionVigente =
      !data || Number(data?.codigoRespuesta) === 2;

    if (sinInformacionVigente) {
      const mensaje =
        mensajePorPlan ||
        'No se encontraron datos asociados al número de documento ingresado.';

      this.openDialog(
        this.dialog,
        mensaje,
        '',
        0,
        () => {
          this.prepararReintentoGrupoAfinidad();
        }
      );

      return;

      return;
    }

    this.datosEmpresa = data;
    this.valPersona = data;
  }

  private isPlanColectivo( tipoPlan: string ): boolean {
    return tipoPlan === 'C' || tipoPlan === 'GA';
  }

  private getTipoPlanSeleccionado(): string {
    return ( this.dialogData?.tipoPlan ?? '' )
      .toString()
      .trim()
      .toUpperCase();
  }

  get permitirNuevaConsulta(): boolean {
    return (
      !this.dialogData?.isEditMode ||
      this.isPlanColectivo(this.getTipoPlanSeleccionado())
    );
  }

  private prepararReintentoGrupoAfinidad(): void {
    this.datosEmpresa = null;
    this.valPersona = null;
    this.listContrato = [];
    this.valContratos = [];
    this.opcionesNew = false;

    // El NI anterior pertenecía al colectivo.
    // No se borra el documento para que el usuario pueda corregirlo
    this.form.documento.messages = null;
  }

  private getMensajeNoVigentePorTipoPlan( tipoPlan: string ): string {
    if ( tipoPlan === 'C' ) {
      return 'No se encontraron colectivos vigentes asociados al número de documento ingresado.';
    }

    else if ( tipoPlan === 'GA' ) {
      return 'No se encontraron grupos de afinidad vigentes asociados al número de documento ingresado.';
    }

    return '';
  }

  searchEmpresaOutputFailure(error: any): void {
    this.spinner.hide();

    const tipoPlan = this.getTipoPlanSeleccionado();
    const esGrupoAfinidad = tipoPlan === 'GA';

    const backendMessage =
      error?.error?.errorMessage ||
      error?.error?.message ||
      error?.message ||
      'Ha ocurrido un error al buscar los datos de la empresa.';

    const mensajePorPlan =
      this.getMensajeNoVigentePorTipoPlan(tipoPlan);

    const esRespuestaSinRegistros =
      typeof backendMessage === 'string' &&
      (
        backendMessage.toLowerCase().includes('no se encontraron registros') ||
        backendMessage.toLowerCase().includes('no se encontraron grupos') ||
        error?.status === 404
      );

    if (esRespuestaSinRegistros) {
      this.openDialog(
        this.dialog,
        mensajePorPlan || backendMessage,
        '',
        0,
        () => this.prepararReintentoGrupoAfinidad()
      );

      return;
    }

    this.openDialog(
      this.dialog,
      '',
      backendMessage,
      0,
      () => {}
    );
  }

  validarTipoAsesor(): void {
    if ( !this.asesorLogueado || !this.asesorContratante ) {
      return;
    }

    // Si el asesor logueado NO está activo, no se valida
    if ( !this.asesorLogueado.activo ) {
      return;
    }

    const tipoLogueado = this.asesorLogueado.tipo;
    const tipoContratante = this.asesorContratante.tipo;

    // Regla clave: ambos internos → NO alerta
    if ( tipoLogueado === 'Interno' && tipoContratante === 'Interno' ) {
      console.log( 'Ambos son internos' );

      return;
    }

    // Cualquier otro caso → ALERTA
    const mensaje = `Advertencia: Este usuario ha sido gestionado por el asesor ${ tipoLogueado.toLowerCase() } ${ this.asesorLogueado.nombre }.`;

    this.openDialog( this.dialog, mensaje, '', 0, () => { } );
  }

  homologar( codigo: string, tipo: string | number ) {
    var nombre = '';
    // Verificar que tipo sea uno de los valores esperados
    if ( tipo === 'linea' || tipo === 'plan' || tipo === 'programa' ) {
      var result = this.listHomo[ tipo ].filter( ( b ) => b.codigo == codigo );
      nombre = result.length > 0 ? result[ 0 ].nombre : codigo;
    } else {
      // Manejar el caso donde tipo no es uno de los valores esperados
      console.error( `Tipo inválido: ${ tipo }` );
      nombre = codigo;
    }
    return nombre;
  }

  continuar( estado: any ) {

    let documentoContratante = '';
    let tipoDocumentoContratante = '';

    try {
      const contratoRadicadoActual = JSON.parse(localStorage.getItem('contrato_radicado_actual') || '{}');

      tipoDocumentoContratante = (
        contratoRadicadoActual?.tipoDocumento ??
        contratoRadicadoActual?.persona?.docu_tipo ??
        contratoRadicadoActual?.Contrato?.[0]?.docu_tipo ??
        ''
      ).toString().trim();

      documentoContratante = (
        contratoRadicadoActual?.numeroDocumento ??
        contratoRadicadoActual?.persona?.docu_nro ??
        contratoRadicadoActual?.Contrato?.[0]?.docu_nro ??
        ''
      ).toString().trim();

    } catch (error) {
      console.error('Error al leer contrato_radicado_actual:', error);
    }

    // GUARDAR EN LOCAL STORAGE
    const contratoRadicado = {
      tipoDocumento : tipoDocumentoContratante,
      numeroDocumento : documentoContratante,
      contrato: this.valContratos,
      persona: this.valPersona,
      asesor: this.asesorLogueado,
      fecha: new Date().toISOString(),
    };

    localStorage.setItem(
      'contrato_radicado',
      JSON.stringify( contratoRadicado ),
    );

    console.log(
      'LOCAL STORAGE:',
      JSON.parse( localStorage.getItem( 'contrato_radicado' )! ),
    );

    // cerrar modal
    this.dialogRef.close( {
      select: this.valContratos,
      all: this.listContrato,
      persona: this.valPersona,
      tipoDocumento: this.selectedTipoDocumento,
      numeroDocumento: this.documento
    } );

  }

  // Dentro de DialogContratComponent
  onSelect( obj: any ) {
    this.valContratos = obj;
  }
}

